"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPendingAttestationsResponseToJSON = exports.GetPendingAttestationsResponseFromJSONTyped = exports.GetPendingAttestationsResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GetPendingAttestationsResponseFromJSON(json) {
    return GetPendingAttestationsResponseFromJSONTyped(json, false);
}
exports.GetPendingAttestationsResponseFromJSON = GetPendingAttestationsResponseFromJSON;
function GetPendingAttestationsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'attestations': !(0, runtime_1.exists)(json, 'attestations') ? undefined : (json['attestations'].map(_1.PendingAttestationFromJSON)),
        'totalCount': !(0, runtime_1.exists)(json, 'totalCount') ? undefined : json['totalCount'],
    };
}
exports.GetPendingAttestationsResponseFromJSONTyped = GetPendingAttestationsResponseFromJSONTyped;
function GetPendingAttestationsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'attestations': value.attestations === undefined ? undefined : (value.attestations.map(_1.PendingAttestationToJSON)),
        'totalCount': value.totalCount,
    };
}
exports.GetPendingAttestationsResponseToJSON = GetPendingAttestationsResponseToJSON;
